import { render, staticRenderFns } from "./tableTemplate.vue?vue&type=template&id=627410e2&scoped=true&"
import script from "./tableTemplate.vue?vue&type=script&lang=js&"
export * from "./tableTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627410e2",
  null
  
)

export default component.exports